angular.module('trainerWebApp.controllers')
  .controller('GetStartedCtrl', ['$scope', '$routeParams', '$location', 'trackingService', 'getStartedUpload',
    function ($scope, $routeParams, $location, trackingService, getStartedUpload) {
      //If they've already made it thru GS, keep them in the app
//    if (mfConfig.appLoadingStarted)
//      return $location.path('/TMS/Home');

      $scope.welcomeShown = false;

      var prevParams = {};
      $scope.$on("$routeUpdate", function (e, route) {
        var params = route.params;
        if (angular.equals(params, prevParams))
          return;

        cancelUploadAndConversionTracking();
        flow.welcome.show();
        setHashFragment({});
      });
      setHashFragment({});

      var flow = setupFlows();
      var lastPercent;
      var convertInfo = {};
      var convertStatus;
      var percentTrackers = {};
      var courseID;
      var enqueueConversionRequest;
      var lastConvertPercent = -1;
      var currentGetConvertStatus;
      var showCongratsFlowTimeout;
      var gaActions = trackingService.pages.getStarted.actions;


      $scope.$on('$destroy', function () {
        $('#lightboxBG').hide();
        getStartedUpload.destroy();
      });

      var img = $('<img src="/Trainer/images/getStarted/welcomeImgInner.jpg" />');
      $(img).load(function() {
        $scope.welcomeShown = true;
        if(mfConfig.appLoadingStarted) {
          flow.welcome.animSpeed = 0;
          flow.welcome.show();
        } else {
          $("#welcomeAnimWrapper").css("display", "block");
          flow.welcomeAnim.show();
        }
        $scope.$apply(function() {
          $scope.page.header = 'pages/getStarted/header.html';
          $scope.page.footer = 'pages/footer/footer.html';
        });
      });

      initUploader();

      function post(uri, data, cb) {
        $.ajax(uri, {
          type: 'POST',
          data: data,
          success: cb,
          dataType: "json"
        });
      }

      function setHashFragment(params) {
        $location.search(params);
        prevParams = params;
      }

      function initUploader() {
        getStartedUpload.initUploader(
          {
            fileSelectorSwfId: "fileSelectorSwf",
            button_width: 315,
            button_height: 33,
            fileDialogCompleteHandler: fileDialogComplete,
            fileDialogStartHandler: fileDialogStart,
            uploadStartHandler: uploadStart,
            uploadProgressHandler: uploadProgress,
            uploadSuccessHandler: uploadSuccess,
            fileUploadErrorHandler: fileUploadErrorHandler,
            conversionStartHandler: conversionStartedHandler,
            conversionErrorHandler: conversionErrorHandler,
            conversionProgressHandler: conversionProgressHandler,
            conversionSuccessHandler: conversionSuccessHandler
          }
        );

        if (Modernizr.canvas) {
          $("#conversionCanvas").show();
          $("#conversionImage").hide();
          if (!viz) {
            viz = new Visualization();
            viz.init("viz");
          }
        } else {
          $("#conversionCanvas").hide();
          $("#conversionImage").show();
        }

        function fileUploadErrorHandler(error) {
          if (error.isCanceled) {
            uploadCancelled();
            return;
          }

          if (error.isLogRequired) {
            post("/ActionLogs.aspx/LogGetStartedErrorAction", { action: "GetStartedUploadErrorGeneric", errorMessage: error.message});
          }

          if (error.isShowError) {
            showErrorDialog(error.title, error.message);
          }
        }

        function fileDialogComplete(numFilesSelected, numFilesQueued) {
          setHashFragment({gs: 'Uploading'});
          $scope.$apply();

          resetUploadConversionAnimation(0);

          /* fileDialogComplete fires AFTER any queue error events are thrown. Starting upload only if file was queued.*/
          if (numFilesQueued > 0) {
            initUploadState();
            flow.upload.show();
            startUploadAnimation();

//        post("/ActionLogs.aspx/LogGetStartedAction", { action: "GetStartedFindFile"});
            trackGS(gaActions.GettingStarted_FindFile);
          }
        }

        function fileDialogStart() {
          trackingService.trackKissMetricsEvent("clicked on", {
            action: "clicked upload file on GS"
          });
        }

        function initUploadState() {
          $('#convertProgress, #uploadProgress').width(0);
          percentTrackers = {};
          convertStatus = null;
          lastConvertPercent = -1;
          lastPercent = -1;
          $("#convertUploadHeader").css("opacity", 1, function () {
            $(this).css('filter', '');
          });
          $("#uploadProgressOuter").css("opacity", 1);
        }

        function uploadStart() {
          $('#congratsSubTitle').html("We just transformed your file into<br />an online course.");
        }

        function uploadProgress(bytesLoaded, bytesTotal) {
          var percent = bytesLoaded / bytesTotal * 100;

          updatePercents("#uploadProgress", 3000, percent * 0.99, null, null);
        }

        function uploadSuccess(serverData) {
          updatePercents("#uploadProgress", 250, 100, null, (function (data) {
            stopUploadAnimation();

            $("#convertUploadHeader").animate({ opacity: 0 }, 2000);
            $("#uploadProgressOuter").animate({ opacity: 0 }, 2000, (function (data) {
              onFinishUpload(data);
            })(data));
          })(jQuery.parseJSON(serverData)));
        }

        function uploadCancelled() {
          setHashFragment({});
        }

        function uploadValidationError(errorTitle, errorMessage) {
          showErrorDialog(errorTitle, errorMessage, false);
        }
      }

      function setupFlows() {
        var FLOWTYPE_PAGE = "FLOWTYPE_PAGE";
        var FLOWTYPE_LIGHTBOX = "FLOWTYPE_LIGHTBOX";

        var flow = initFlows({
          welcomeAnim: {},
          welcome: {},
          upload: { type: FLOWTYPE_LIGHTBOX },
          alert: { type: FLOWTYPE_LIGHTBOX }
        });


        flow.welcomeAnim.onShow = function () {
          $('#welcomeImg1').delay(500).fadeIn(400);
          $('#welcomeImg2').delay(1250).fadeIn(400);
          $('#welcomeImg3').delay(2000).fadeIn(400);

          $('#welcomeImgMain').delay(3000).fadeOut(500);
          flow.welcome.showAfter(3500);
          trackGS(gaActions.GettingStarted);
        };

        flow.welcome.onShown = function () {
          $('.swfupload').css('left', 0);
          flow.welcome.animSpeed = 0;
        };
        flow.upload.onShow = flow.alert.onShow = function () {
          $('.swfupload').css('left', -20000);
        };

        return flow;

        function initFlows(flow) {
          for (var flowName in flow) {
            var flowStep = flow[flowName];

            flowStep.name = flowName;
            flowStep.type = flowStep.type || FLOWTYPE_PAGE;
            flowStep.elem = flowStep.elem || $('#' + flowStep.name + 'Wrapper');

            flowStep.show = showFlow;
            flowStep.showAfter = showFlowAfter;

            flowStep.onShow = function () {
            };
            flowStep.onShown = function () {
            };
            flowStep.onHide = function () {
            };
            flowStep.onHidden = function () {
            };
            flowStep.animTimeoutID = 0;
            flowStep.animSpeed = 400;

            flowStep._doShow = function () {
              this.onShow();
              this.elem.fadeIn(this.animSpeed);
              this.animTimeoutID = setTimeout(this.onShown, this.animSpeed + 50);
            };
            flowStep._doHide = function () {
              this.onHide();
              this.elem.fadeOut(this.animSpeed);
              this.animTimeoutID = setTimeout(this.onHidden, this.animSpeed + 50);
            };

            flow[flowStep.name] = flowStep;
          }
          return flow;

          function showFlowAfter(delay) {
            var me = this;
            return setTimeout(function () {
              me.show();
            }, delay);
          }

          function showFlow() {
            var hidePages = this.type == FLOWTYPE_PAGE;

            this.type == FLOWTYPE_LIGHTBOX ? $('#lightboxBG').fadeTo(500, .75) : $('#lightboxBG').fadeOut();

            for (var flowName in flow) {
              var flowStep = flow[flowName];
              if (flowStep == this) {
                flowStep._doShow();
              } else if (hidePages || flowStep.type != FLOWTYPE_PAGE) {
                flowStep._doHide();
              }
            }
          }
        }
      }

      function onFinishUpload(serverData) {
        // Don't send start conversion request if upload was canceled
        if (serverData && jQuery.inArray(serverData.token, mfConfig.canceledTokens) >= 0) {
          return;
        }

        if (!serverData) {
          var msg = 'Sorry, it appears your internet connection has been lost and your file hasn\'t been uploaded. You should check your connection, refresh the page, then re-upload your file.';
          showErrorDialog('Internet Connection Lost', msg, false);
          return;
        }
        getStartedUpload.enqueueConversion();
      }

      function conversionStartedHandler(data) {
        convertInfo = data;
        lastPercent = -1;
        updatePercents("#uploadProgress", 0, 0);
        runUploadConversionAnimation();
        startConversionPolling();
        courseID = data.courseID;
        trackGS(gaActions.GettingStarted_BuildingCourseLoader);
      }

      function conversionErrorHandler(error) {
        showErrorDialog(error.title, error.message, error.isRequiredUserPermissionToUseFile);
      }

      function conversionProgressHandler(status) {
        convertStatus = status;
        percentTrackers.convert = convertStatus.percent * 0.999; //Make sure the status never quite reaches 100% until conversion is complete
        percentTrackers.app = mfConfig.appLoadPercent;
        updatePercent(2000);

        if ((convertStatus.isComplete && mfConfig.appLoadPercent >= 100) || convertStatus.convertFailed || convertStatus.courseRemoved) {
          updatePercent(750, 100);
        }
      }

      function conversionSuccessHandler(status) {
        convertStatus = status;
        mfConfig.thumbnailUrl = convertStatus.thumbnailUrl;
        showCongratsFlowTimeout = setTimeout(function () {
          $location.path('/getStartedCongrats').search({
            courseId: convertInfo.courseID,
            missingId: convertStatus.hasMissingContent ? convertStatus.contentFileDataID : 0,
            useSample: convertStatus.useSample || false
          });
          $scope.$apply();
        }, 1000);
      }

      function resetUploadConversionAnimation(startingSlide) {
        $("#convertUploadHeader").css("opacity", 1, function () {
          $(this).css('filter', '');
        });
        $("#uploadProgressOuter").css("opacity", 1);
        $("#uploadFileAnimation").cycle({ startingSlide: startingSlide, before: function () {
        } }).cycle('stop');
        $("#convertUploadHeader").html(startingSlide == 0 ? "Uploading your file..." : "Creating your course...");
      }

      function runUploadConversionAnimation() {
        $("#uploadFileAnimation").cycle({
          fx: 'scrollLeft',
          speed: 1000,
          timeout: 0,
          startingSlide: 0,
          easing: 'easeInOutQuad',
          after: function (isNext) {
            if (!isNext) {
              return;
            }

            $("#convertUploadHeader").html("Creating your course...");
            $("#convertUploadHeader").delay(1000).animate({ opacity: 1 }, 2000, function () {
              $(this).css('filter', '');
            });
            $("#uploadProgressOuter").delay(1000).animate({ opacity: 1 }, 2000);
          }
        }).cycle("next");
      }

      function updatePercent(duration, forceToPercentage) {
        var percent;
        if (forceToPercentage && isFinite(forceToPercentage))
          percent = forceToPercentage;
        else {
          percent = 0;
          var num = 0;
          for (var tracker in percentTrackers) {
            percent += percentTrackers[tracker];
            num++;
          }

          if (num)
            percent /= num;
        }

        updatePercents("#uploadProgress", duration, percent);
      }

      function updatePercents(selector, duration, percent, correctionFn, callback) {
        var progressStepWidth = 240 / 100;

        if (lastPercent >= percent) {
          return;
        }
        lastPercent = percent;
        var innerPercent = percent;
        if (correctionFn && typeof correctionFn === "Function") {
          innerPercent = correctionFn(innerPercent);
        }

        $(selector).stop(true).animate({ width: innerPercent * progressStepWidth }, { duration: duration, easing: 'easeOutCubic', complete: callback });
      }

      function startUploadAnimation(force) {
        $("#uploadCompleteImage").hide();
        $("#uploadingImage").show();
      }

      function stopUploadAnimation() {
        $("#uploadCompleteImage").show();
        $("#uploadingImage").hide();
      }

      $scope.openTourVideo = function (pageURL, w, h) {
        var left = (screen.width / 2) - (w / 2);
        var top = (screen.height / 2) - (h / 2) - 100;
        window.open(pageURL, null, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        post("/ActionLogs.aspx/LogGetStartedAction", { action: "GetStartedTour"});
        trackGS(gaActions.GettingStarted_Tour_Video);
      };

      $scope.skipToApp = function (useSimpleLoader) {
        if (useSimpleLoader && !mfConfig.appLoadingStarted) {
          mfConfig.SwfUrl = mfConfig.SwfUrlB;
          mfConfig.SwfMarketingUrl = '';
        }

        post("/ActionLogs.aspx/LogGetStartedAction", { action: "GetStartedSkipToHome" });
        trackGS(gaActions.GettingStarted_SkipToHome);

        mfConfig.defaultRoute = mfConfig.trainerHomeUrl;
        $location.path(mfConfig.trainerHomeUrl);
        $location.search('gs', null);
        return;
      };

      function loadFlexApp() {
        if (mfConfig.appLoadingStarted)
          return;

        post("/ActionLogs.aspx/LogGetStartedAction", { action: "TrainerAppLoading" });
        MF.loadAppSwf();
      }

      function breakout_of_frame() {
        if (top.location != location) {
          top.location.href = document.location.href;
        }
      }

      function showErrorDialog(title, message, requireUserPermissionToUseFile) {
        $('#alertTitle').html(title);
        $('#alertMessage').html(message);

        if (requireUserPermissionToUseFile)
          $('#alertButtons').html('<button id=alertYes>Yes</button><button id=alertNo>No</button>');
        else
          $('#alertButtons').html('<button id=alertOK>OK</button>');

        $('#alertOK, #alertNo').click(function () {
          $location.url('/getStarted');
          $scope.$apply();
        });
        $('#alertYes').click(function () {
          setTimeout(showErrorResearchConfirmed, 250);
        });
        flow.alert.show();
      }

      function showErrorResearchConfirmed() {
        showErrorDialog('Your conversion issue has been reported', 'Thank you. Our team will investigate this issue.');

        post('/TrainerGS/AllowFileUsageForErrorInvestigation', { conversionID: convertStatus.conversionID });
      }

      function trackGS(eventName) {
        trackingService.trackEvent(trackingService.pages.getStarted.name, eventName);
      }

      function startConversionPolling() {
        setHashFragment({gs: 'Converting', courseId: convertInfo.courseID});
        $scope.$apply();
        setTimeout(loadFlexApp, 1000);
      }

      function cancelUploadAndConversionTracking() {
        getStartedUpload.cancelUpload();

        clearTimeout(showCongratsFlowTimeout);
      }

    }]);

function doGimmeCookie() {
  $.ajax('/tests/qa/sess.aspx', {
    type: 'GET',
    success: function (data) {
      $('#gimmeCookie').append(data);
    }
  });

}
